{
  "version": 1,
  "asset_id": "07289f18-dcab-4511-93d5-e541ee95f958",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/07289f18-dcab-4511-93d5-e541ee95f958/destination-roofing-crew-citrus-county-fl-1280.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/07289f18-dcab-4511-93d5-e541ee95f958/destination-roofing-crew-citrus-county-fl-1280.webp",
  "original_filename": "destination-roofing-crew-citrus-county-fl-1280.webp",
  "size": 128230,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:33Z"
}
